import { useCallback } from 'react';

import { useMutation } from '@tanstack/react-query';

import { useStudentApi } from '../../api';
import { StudentResponse } from '../../types';

type AddStudentRequest = {
  first_name: string;
  last_name: string;
  student_id: string;
};
const useAddStudent = () => {
  const StudentApi = useStudentApi();

  const addStudent = useCallback(
    async (request: AddStudentRequest) => {
      const response = await StudentApi.post<StudentResponse>('/consumer/students', request);
      return response.data;
    },
    [StudentApi]
  );

  return useMutation({
    mutationFn: addStudent,
  });
};

export { useAddStudent };
